<template>
	<div class="forgot-password-modal" v-if="visible">
		<div class="modal-overlay" @click="close"></div>
		<div class="modal-content">
			<div class="modal-header">
				<h3 class="modal-title">找回密码</h3>
				<i class="el-icon-close close-btn" @click="close"></i>
			</div>
			<div class="modal-body">
				<form class="forgot-form" @submit.prevent="handleSubmit">
					<div class="form-group">
						<label class="form-label">手机号码</label>
						<div class="input-group">
							<input type="tel" class="form-input" placeholder="请输入注册时使用的手机号码" v-model="form.phone"
								required @input="validatePhone">
							<i class="el-icon-phone input-icon"></i>
						</div>
						<div class="error-message" v-if="errors.phone">
							{{ errors.phone }}
						</div>
					</div>

					<div class="form-group">
						<label class="form-label">验证码</label>
						<div class="code-group">
							<div class="input-group code-input">
								<input type="text" class="form-input" placeholder="请输入验证码" v-model="form.code" required
									maxlength="6" @input="validateCode">
								<i class="el-icon-circle-check input-icon"></i>
							</div>
							<button type="button" class="code-btn" :disabled="codeCountdown > 0 || !!errors.phone"
								@click="sendVerificationCode">
								{{ codeCountdown > 0 ? `${codeCountdown}秒后重试` : '获取验证码' }}
							</button>
						</div>
						<div class="error-message" v-if="errors.code">{{ errors.code }}</div>
					</div>

					<div class="form-group">
						<label class="form-label">新密码</label>
						<div class="input-group">
							<input type="password" class="form-input" placeholder="请设置新密码" v-model="form.newPassword"
								required @input="validateNewPassword">
							<i class="el-icon-lock input-icon"></i>
						</div>
						<div class="error-message" v-if="errors.newPassword">
							{{ errors.newPassword }}
						</div>
					</div>

					<div class="form-group">
						<label class="form-label">确认新密码</label>
						<div class="input-group">
							<input type="password" class="form-input" placeholder="请再次输入新密码"
								v-model="form.confirmNewPassword" required @input="validateConfirmPassword">
							<i class="el-icon-lock input-icon"></i>
						</div>
						<div class="error-message" v-if="errors.confirmNewPassword">
							{{ errors.confirmNewPassword }}
						</div>
					</div>

					<button type="submit" class="btn btn-primary" :disabled="!isFormValid || loading">
						<span v-if="loading" class="loading-spinner"></span>
						{{ loading ? '重置中...' : '立即重置密码' }}
					</button>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ForgotPasswordModal',
		props: {
			visible: {
				type: Boolean,
				default: false
			},
			loading: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				form: {
					phone: '',
					code: '',
					newPassword: '',
					confirmNewPassword: ''
				},
				errors: {
					phone: '',
					code: '',
					newPassword: '',
					confirmNewPassword: ''
				},
				codeCountdown: 0
			}
		},
		computed: {
			isFormValid() {
				return (
					this.form.phone &&
					this.form.code &&
					this.form.newPassword &&
					this.form.confirmNewPassword &&
					!this.errors.phone &&
					!this.errors.code &&
					!this.errors.newPassword &&
					!this.errors.confirmNewPassword
				)
			}
		},
		methods: {
			validatePhone() {
				const phoneRegex = /^1[3-9]\d{9}$/
				if (!this.form.phone) {
					this.errors.phone = '请输入手机号码'
				} else if (!phoneRegex.test(this.form.phone)) {
					this.errors.phone = '手机号码格式不正确'
				} else {
					this.errors.phone = ''
				}
			},
			validateCode() {
				if (!this.form.code) {
					this.errors.code = '请输入验证码'
				} else if (this.form.code.length !== 6) {
					this.errors.code = '验证码应为6位数字'
				} else {
					this.errors.code = ''
				}
			},
			validateNewPassword() {
				if (!this.form.newPassword) {
					this.errors.newPassword = '请输入新密码'
				} else if (this.form.newPassword.length < 6) {
					this.errors.newPassword = '密码长度至少6位'
				} else {
					this.errors.newPassword = ''
				}
				if (this.form.confirmNewPassword) {
					this.validateConfirmPassword()
				}
			},
			validateConfirmPassword() {
				if (!this.form.confirmNewPassword) {
					this.errors.confirmNewPassword = '请确认新密码'
				} else if (this.form.newPassword !== this.form.confirmNewPassword) {
					this.errors.confirmNewPassword = '两次输入的密码不一致'
				} else {
					this.errors.confirmNewPassword = ''
				}
			},
			sendVerificationCode() {
				this.validatePhone()
				if (this.errors.phone) {
					return
				}

				this.$emit('send-code', this.form.phone)

				// 开始倒计时
				this.codeCountdown = 60
				const timer = setInterval(() => {
					this.codeCountdown--
					if (this.codeCountdown <= 0) {
						clearInterval(timer)
					}
				}, 1000)
			},
			handleSubmit() {
				if (this.isFormValid) {
					this.$emit('submit', this.form)
				}
			},
			close() {
				this.resetForm()
				this.$emit('close')
			},
			resetForm() {
				this.form = {
					phone: '',
					code: '',
					newPassword: '',
					confirmNewPassword: ''
				}
				this.errors = {
					phone: '',
					code: '',
					newPassword: '',
					confirmNewPassword: ''
				}
				this.codeCountdown = 0
			}
		},
		watch: {
			visible(newVal) {
				if (!newVal) {
					this.resetForm()
				}
			}
		}
	}
</script>

<style scoped>
	.forgot-password-modal {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 1000;
	}

	.modal-overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
	}

	.modal-content {
		position: relative;
		width: 90%;
		max-width: 420px;
		background: white;
		border-radius: 12px;
		box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
		overflow: hidden;
		animation: modalAppear 0.3s ease-out;
		max-height: 85vh;
		display: flex;
		flex-direction: column;
	}

	@keyframes modalAppear {
		from {
			opacity: 0;
			transform: translateY(-20px) scale(0.95);
		}

		to {
			opacity: 1;
			transform: translateY(0) scale(1);
		}
	}

	.modal-header {
		padding: 20px 24px 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.modal-title {
		font-size: 18px;
		font-weight: 600;
		color: #333;
		margin: 0;
	}

	.close-btn {
		font-size: 22px;
		cursor: pointer;
		color: #999;
		transition: color 0.3s ease;
	}

	.close-btn:hover {
		color: #333;
	}

	.modal-body {
		padding: 20px 24px;
		overflow-y: auto;
		flex: 1;
		min-height: 0;
	}

	.forgot-form {
		animation: fadeIn 0.3s ease-out;
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	/* 表单样式 */
	.form-group {
		margin-bottom: 16px;
	}

	.form-label {
		display: block;
		margin-bottom: 6px;
		font-size: 13px;
		color: #666;
		font-weight: 500;
	}

	.input-group {
		position: relative;
	}

	.form-input {
		width: 100%;
		padding: 12px 14px;
		border: 1px solid #e0e0e0;
		border-radius: 8px;
		font-size: 14px;
		color: #333;
		transition: all 0.3s ease;
		background: #fafafa;
	}

	.form-input:focus {
		outline: none;
		border-color: #2280FD;
		background: white;
		box-shadow: 0 0 0 3px rgba(34, 128, 253, 0.1);
	}

	.input-icon {
		position: absolute;
		right: 14px;
		top: 50%;
		transform: translateY(-50%);
		color: #999;
		font-size: 14px;
	}

	.error-message {
		color: #ff4d4f;
		font-size: 12px;
		margin-top: 4px;
		height: 16px;
	}

	.code-group {
		display: flex;
		gap: 10px;
	}

	.code-input {
		flex: 1;
	}

	.code-btn {
		padding: 0 16px;
		background: #f0f0f0;
		border: 1px solid #e0e0e0;
		border-radius: 8px;
		color: #666;
		cursor: pointer;
		transition: all 0.3s ease;
		white-space: nowrap;
		font-size: 13px;
	}

	.code-btn:hover:not(:disabled) {
		background: #e5e5e5;
	}

	.code-btn:disabled {
		background: #f5f5f5;
		color: #ccc;
		cursor: not-allowed;
	}

	.btn {
		width: 100%;
		padding: 12px;
		border: none;
		border-radius: 8px;
		font-size: 14px;
		font-weight: 500;
		cursor: pointer;
		transition: all 0.3s ease;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 6px;
		position: relative;
	}

	.btn:disabled {
		opacity: 0.6;
		cursor: not-allowed;
		transform: none !important;
		box-shadow: none !important;
	}

	.btn-primary {
		background: #2280FD;
		color: white;
		box-shadow: 0 3px 10px rgba(34, 128, 253, 0.3);
	}

	.btn-primary:hover:not(:disabled) {
		background: #1a6fd0;
		transform: translateY(-1px);
		box-shadow: 0 5px 15px rgba(34, 128, 253, 0.4);
	}

	.btn-primary:active:not(:disabled) {
		transform: translateY(0);
	}

	.loading-spinner {
		width: 16px;
		height: 16px;
		border: 2px solid rgba(255, 255, 255, 0.3);
		border-radius: 50%;
		border-top-color: white;
		animation: spin 1s ease-in-out infinite;
	}

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}

	/* 响应式样式 */
	@media (max-width: 480px) {
		.modal-content {
			max-width: 95%;
			border-radius: 10px;
			max-height: 90vh;
		}

		.modal-header {
			padding: 15px 20px 0;
		}

		.modal-body {
			padding: 15px 20px;
		}

		.modal-title {
			font-size: 16px;
		}

		.close-btn {
			font-size: 18px;
		}
	}
</style>